var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGiftIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 32,
    viewBox: "0 0 31 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_206_5842)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M27.8907 17.2402H17.9625V31.9968H27.8907C28.6177 31.9968 29.203 31.4771 29.203 30.8389V18.3981C29.203 17.7567 28.6139 17.2402 27.8907 17.2402Z",
    fill: "#2653F1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.797 18.4015V30.8423C1.797 31.4838 2.38605 32.0002 3.10932 32.0002H13.0375V17.2437H3.10932C2.38232 17.2437 1.797 17.7634 1.797 18.4015Z",
    fill: "#2653F1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 11.0591V14.6907C0 15.3322 0.589056 15.8486 1.31233 15.8486H13.0375V9.89795H1.31233C0.585328 9.89795 0 10.4177 0 11.0558L0 11.0591Z",
    fill: "#2653F1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.6877 9.90137H17.9364L17.9625 15.852H29.6877C30.4147 15.852 31 15.3323 31 14.6941V11.0626C31 10.4211 30.4109 9.90466 29.6877 9.90466V9.90137Z",
    fill: "#2653F1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.45063 8.59211C5.60348 8.66776 5.84209 8.78947 6.54299 8.78947H24.2855C25.0535 8.78947 25.3592 8.66118 25.5233 8.57566C26.6977 7.96382 27.4358 6.68092 27.4358 5.04276C27.4358 3.82566 26.9996 2.61184 26.2391 1.71382C25.307 0.608553 23.9239 0 22.3431 0C22.2126 0 22.0821 0.00328947 21.9479 0.0131579C17.8059 0.266447 16.1245 3.73355 15.4683 5.97039C14.8084 3.73355 13.127 0.263158 8.98869 0.0131579C8.85448 0.00657895 8.72399 0 8.5935 0C7.01647 0 5.63331 0.608553 4.69753 1.71382C3.93698 2.61184 3.50078 3.82566 3.50078 5.04276C3.50078 6.69737 4.25387 7.99013 5.4469 8.59211H5.45063ZM22.1082 2.09211C22.1865 2.08882 22.2648 2.08553 22.3431 2.08553C23.1782 2.08553 23.853 2.37829 24.3414 2.96053C24.8037 3.50658 25.0684 4.26645 25.0684 5.04276C25.0684 5.68092 24.8186 6.88487 23.8679 6.88487H17.653C18.0818 5.21053 19.2375 2.26645 22.112 2.09211H22.1082ZM6.59146 2.95724C7.07985 2.37829 7.75466 2.08224 8.58977 2.08224C8.66434 2.08224 8.74263 2.08224 8.82465 2.08882C11.6991 2.26316 12.8548 5.20724 13.2836 6.88158H7.06867C6.11798 6.88158 5.86819 5.67434 5.86819 5.03947C5.86819 4.26316 6.13289 3.50329 6.59519 2.95724H6.59146Z",
    fill: "#2653F1"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_206_5842"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 31,
    height: 32,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGiftIcon);
export default __webpack_public_path__ + "static/media/giftIcon.a08c3a5877f3f22707c8708bd07d5292.svg";
export { ForwardRef as ReactComponent };